export const ASSET_DETAILS = '/asset';
export const ASSET_INVENTORY = '/organization/assets';
export const ASSET_MODEL_DETAILS = '/asset-model';
export const CSV_REPORTS = '/csv-reports';
export const ENGINEANALYSIS = '/engineanalysis';
export const FLEET = '/fleet';
export const MAINTENANCE = '/maintenance';
export const MAINTENANCE_REPORT = '/maintenance-report';
export const MAP = '/map';
export const REPORTS = '/reports';
export const WATERTRANSFER = '/watertransfer';
